/* globals $ */

class Collapsible {
  constructor($elem) {
    $elem.find(".collapsible").click((e) => {
      e.preventDefault();
      $(e.currentTarget).next().slideToggle("fast");
      $(e.currentTarget).toggleClass("open");
    });
  }
}

export { Collapsible };
